import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppSettings } from "src/app/app.settings";
import { Settings } from "src/app/app.settings.model";
import { ProfileService } from "src/app/features/accounts/services/profile/profile-services.service";
import { AuthenticationService } from "src/app/shared/services/authentication/authentication.service";

@Component({
  standalone: true,
  selector: "app-login-callback",
  templateUrl: "./login-callback.component.html",
  styleUrls: ["./login-callback.component.scss"],
})
export class LoginCallbackComponent {
  public settings: Settings;
  private callbackHandled = false;

  constructor(
    private appSettings: AppSettings,
    private profileService: ProfileService,
    private auth: AuthenticationService,
    private router: Router
  ) {
    this.settings = this.appSettings.settings;
  }

  async ngOnInit(): Promise<void> {
    await this.runCallbackOnce();
    this.auth.authenticationChange$.subscribe(async (auth) => {
      if (auth) {
        await this.profileService.getInitialApplicationState(false);
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.settings.loadingSpinner = true;
    }, 0);
  }

  private async runCallbackOnce(): Promise<void> {
    if (this.callbackHandled) {
      return;
    }
    this.callbackHandled = true;
    try {
      if (window.location.hash === "#logout") {
        this.auth.login();
        return;
      }
      const params = new URLSearchParams(window.location.search);
      const hasCallbackParams = params.has("code") && params.has("state");
      if (!hasCallbackParams) {
        this.router.navigate(["/home"]);
        return;
      }
      await this.auth.handleLogin();
    } catch (error) {
      console.error(error);
    }
  }
}
